<script setup lang="ts">
useSeoMeta({
  title: "About Community",
  description: "The one stop platform for Indonesia Furs.",
});

defineOgImageComponent("Default");
</script>

<template>
  <main class="flex flex-col gap-10">
    <hero
      title="About Community"
      description="The one stop platform for Indonesia Furs."
      icon-src="/images/if-logo.svg"
    />

    <article class="container mx-auto prose lg:prose-xl">
      <nuxt-img
        src="/images/ej_community.png"
        alt="Community illustration by EJ"
        preload
        sizes="100vw lg:850px md:700px sm:650px"
      />

      <div class="flex flex-col lg:flex-row gap-10">
        <nuxt-img
          src="/images/kurari_hello.png"
          size="100px"
          class="hidden lg:block flex-grow-0 flex-shrink-0 w-28 h-28"
        />
        <div>
          <h2 class="text-2xl">👋 Apa Kabar!</h2>
          <p>
            Welcome to the Indonesia Furs Community Platform. Here is your
            vibrant and welcoming hub for all things furry! Here, you can find
            and book exciting events. Whether you're new or a veteran in our
            community, our team is ready to support your journey. We're your
            go-to guides, offering answers, resources, and help whenever you
            need it. Feel free to reach out!
          </p>
        </div>
      </div>

      <p>
        Join us on this exhilarating adventure to foster connections and delve
        into experiences. Together we'll create unforgettable moments in our
        Community!
      </p>
      <p>
        Our Mission: To Unite Indonesia's Furry Community in Paw-some
        Adventures!
      </p>
      <p>
        The Indonesia Furs Community Platform is more than a site. It's a warm,
        inclusive embrace aiming to connect furries across Indonesia. Our
        platform is your one-stop hub for everything furry.
      </p>

      <p>
        Join the Indonesia Furs Community and be part of a collective journey.
        Every story shared, every achievement and every digital pawprint
        enriches our story. Let's play, connect, and make memories that last!
      </p>

      <h2 class="text-2xl">🌟 Meet Our Team 🌈</h2>
      <p>
        Meet the heart and soul behind the Indonesia Furs Community Platform, a
        team of dedicated, passionate individuals. Get to know us, dreamers,
        builders, and caretakers of this furry adventure:
      </p>
      <about-team-avatars class="not-prose" />
      <p>
        If you code and interested to contribute to the Indonesia Furs Community
        Platform, we would love to have you on board! Please reach out to us at
        <a href="mailto:tech@furries.id">tech@furries.id</a>.
      </p>

      <h3 class="text-xl">Artwork and Cameo Credits</h3>
      <p>
        Thank you to the following people for their artwork and cameo
        contributions to the Indonesia Furs Community Platform. This project
        would not be possible without their contributions!
      </p>
      <ul>
        <li>
          <a href="https://twitter.com/Claud_Tiger">Claud</a>
        </li>
        <li>
          <a href="https://twitter.com/Kurarifox">Deruu</a>
        </li>
        <li>
          <a href="https://twitter.com/EJ_ArtGarage">EJ</a>
        </li>
        <li>
          <a href="https://twitter.com/PepperPengu">Pepper</a>
        </li>
        <li>
          <a href="https://twitter.com/REORENADE">REORENADE</a>
        </li>
        <li>
          <a href="https://twitter.com/ST4RS6">Sparky</a>
        </li>
      </ul>

      <h2 class="text-2xl">📝 Any Suggestions?</h2>
      <p>
        We're always looking for ways to improve the Indonesia Furs Community
        Platform. If you have any suggestions, please reach out to us at
        <a href="mailto:community@furries.id">community@furries.id</a>.
      </p>
    </article>
  </main>
</template>

<style scoped>
figcaption {
  @apply text-sm;
}
</style>
